import { createScriptLoadQueue } from './script-load-queue';

declare global {
  function gtag(command: 'event', eventName: string, params?: Record<string, unknown>): void;
}

type QueuedEvent = { eventName: string; params?: Record<string, unknown> };

const { queue: eventQueue, flush: flushGtagQueue, enqueue } = createScriptLoadQueue<QueuedEvent>({
  flushHook: '__flushGtagQueue',
  send: ({ eventName, params }) => gtag('event', eventName, params),
});

/**
 * Sends an event to the Google tag, or holds it until the tag's init script
 * has run. Returns `false` only when the event was dropped, for want of
 * Marketing Consent (see `createScriptLoadQueue`).
 */
export function trackGtagEvent(eventName: string, params?: Record<string, unknown>): boolean {
  if (typeof gtag === 'function') {
    gtag('event', eventName, params);
    return true;
  }
  return enqueue({ eventName, params });
}

export { eventQueue, flushGtagQueue };
